import React from "react";
import "./skeleton.css";

const ProjectSkeleton = () => {
  return (
    <div>
      <div class="container flex items-center py-2 flex-row">
        <div className="w-[30%]">
          <div class="line w-[12rem] h-[0.8rem] rounded-md"></div>
        </div>
        <div className="w-[22%]">
          <div class="line2 line w-[8.5rem] h-[1.6rem] rounded"></div>
        </div>
        <div className="w-[23.3%]">
          <div class="line3 line w-[13rem] h-[0.8rem] rounded-md"></div>
        </div>
        <div className="skeletonOption flex items-center gap-4 3xl:gap-5 line4 w-[23.3%] ml-4">
          <div className="line w-[1.5rem] h-[1.5rem] rounded"></div>
          <div className="line w-[1.5rem] h-[1.5rem] rounded"></div>
          <div className="line w-[1.5rem] h-[1.5rem] rounded"></div>
          <div className="line w-[1.5rem] h-[1.5rem] rounded"></div>
        </div>
      </div>
      <div className="w-full bg-gray-700 h-[0.07rem]"></div>
    </div>
  );
};

export default ProjectSkeleton;